import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSystemDispatch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="system-dispatch_svg__lucide system-dispatch_svg__lucide-waypoints-icon system-dispatch_svg__lucide-waypoints"
    {...props}
  >
    <circle cx={12} cy={4.5} r={2.5} />
    <path d="m10.2 6.3-3.9 3.9" />
    <circle cx={4.5} cy={12} r={2.5} />
    <path d="M7 12h10" />
    <circle cx={19.5} cy={12} r={2.5} />
    <path d="m13.8 17.7 3.9-3.9" />
    <circle cx={12} cy={19.5} r={2.5} />
  </svg>
);
const Memo = memo(SvgSystemDispatch);
export default Memo;
